import * as React from 'react';
import * as NumberFormatter from '../utils/NumberFormatter';
function selectedOutcomeEquals(a, b) {
    if (a === b)
        return true;
    if (!a)
        return false;
    if (!b)
        return false;
    return a.bettingTypeKey === b.bettingTypeKey && a.outcomeKey === b.outcomeKey;
}
function getSelection(matches, selectedOutcome) {
    const match = matches.find(match => match.id === selectedOutcome.contestId);
    if (match) {
        const betmarket = match.betmarkets.find(betmarket => betmarket.key === selectedOutcome.bettingTypeKey);
        if (betmarket) {
            const odds = betmarket.odds.find(outcome => outcome.key === selectedOutcome.outcomeKey);
            if (odds) {
                return {
                    match,
                    odds,
                    bettingTypeKey: selectedOutcome.bettingTypeKey,
                    outcomeKey: selectedOutcome.outcomeKey
                };
            }
            else {
                return null;
            }
        }
    }
    return null;
}
function buildDeeplinkParams(matches, selectedOutcomes) {
    return selectedOutcomes.reduce((result, selectedOutcome) => {
        const selection = getSelection(matches, selectedOutcome);
        if (selection) {
            result = result.concat({
                contestId: selection.match.id,
                bettingTypeKey: selection.bettingTypeKey,
                outcomeKey: selection.outcomeKey,
                matchDeeplink: selection.match.metadata.deeplinks,
                outcomeDeeplink: selection.odds.metadata
            });
        }
        return result;
    }, []);
}
export default function useBetslip(matches, buildDeepLink, { stake = 10, mode = 'combi', immediate = false } = {}) {
    const [selectedOutcomes, setSelectedOutcomes] = React.useState({});
    function toggleSelectedOutcome(selectedOutcome) {
        if (immediate) {
            const deeplinks = buildDeeplinkParams(matches, [selectedOutcome]);
            const deeplink = buildDeepLink({ deeplinks });
            console.log('open link', deeplink);
            window.open(deeplink);
        }
        else {
            const currentOutcomeForMatch = selectedOutcomes[selectedOutcome.contestId] || null;
            if (mode === 'single') {
                if (selectedOutcomeEquals(currentOutcomeForMatch, selectedOutcome)) {
                    setSelectedOutcomes({});
                }
                else {
                    setSelectedOutcomes({ [selectedOutcome.contestId]: selectedOutcome });
                }
            }
            else {
                const newSelectedOutcomes = Object.assign({}, selectedOutcomes);
                if (selectedOutcomeEquals(currentOutcomeForMatch, selectedOutcome)) {
                    delete newSelectedOutcomes[selectedOutcome.contestId];
                }
                else {
                    newSelectedOutcomes[selectedOutcome.contestId] = selectedOutcome;
                }
                setSelectedOutcomes(newSelectedOutcomes);
            }
        }
    }
    function isSelectedOutcome(selectedOutcome) {
        return selectedOutcomeEquals(selectedOutcomes[selectedOutcome.contestId], selectedOutcome);
    }
    function isSelectedOutcomeForMatch(contestId) {
        return Boolean(selectedOutcomes[contestId]);
    }
    function reset() {
        setSelectedOutcomes({});
    }
    const combiOdds = Object.values(selectedOutcomes).reduce((result, selectedOutcome) => {
        const selection = getSelection(matches, selectedOutcome);
        if (selection) {
            result *= selection.odds.odds;
        }
        return result;
    }, 1);
    const deeplinks = buildDeeplinkParams(matches, Object.values(selectedOutcomes));
    const selectedOutcomesCount = Object.keys(selectedOutcomes).length;
    const chance = selectedOutcomesCount > 0 ? NumberFormatter.roundOdds(combiOdds) * stake : null;
    return {
        stake,
        chance,
        deeplinks,
        toggleSelectedOutcome,
        isSelectedOutcome,
        selectedOutcomesCount,
        isSelectedOutcomeForMatch,
        reset
    };
}
//# sourceMappingURL=useBetslip.js.map